import { TEST_IDS } from "src/apps/config/testIds";
import { Input } from "src/apps/components/inputs/Input";
import { Select } from "src/apps/components/select/Select";
import { useTranslations } from "src/apps/hooks/useTranslations";
import { FormSectionHeader } from "../../FormSectionHeader";
import {
  ID_NUMBER_INPUT_PLACEHOLDER,
  ID_NUMBER_INPUT_TITLE,
  REPRESENTATIVE_ROLE_PLACEHOLDER,
  REPRESENTATIVE_ROLE_TITLE,
  SECTION_LEGAL_REPRESENTATIVE,
} from "../RepresentedEntityDataForm.constants";
import { Fields, Section } from "../RepresentedEntityDataForm.styles";
import { buildRepresentativeTypeOptions } from "../helpers/buildRepresentativeTypeOptions";
import { RepresentativeInfoMessage } from "./RepresentativeInfoMessage";
import { InlineWarning } from "src/apps/components/inlineWarning/InlineWarning";

import { useTheme } from "styled-components";
import { colors } from "@permisso/permisso-components";

interface Props {
  idNumber: string;
  idNumberError: string;
  representativeRelationType: string;
  representativeRelationTypeError: string;
  isRepresentativeIdNumberEditable: boolean;
  isRepresentativeRelationTypeEditable: boolean;
  onIdNumberChange: (value: string) => void;
  onRepresentativeRelationTypeChange: (value: string) => void;
}

export const LegalRepresentativeSection = ({
  idNumber,
  idNumberError,
  representativeRelationType,
  representativeRelationTypeError,
  isRepresentativeIdNumberEditable,
  isRepresentativeRelationTypeEditable,
  onIdNumberChange,
  onRepresentativeRelationTypeChange,
}: Props) => {
  const { t } = useTranslations();
  const { blackColor } = useTheme();

  const representativeTypeOptions = buildRepresentativeTypeOptions(t);

  return (
    <Section>
      <FormSectionHeader title={t(SECTION_LEGAL_REPRESENTATIVE)} />
      <Fields>
        <Input
          title={t(ID_NUMBER_INPUT_TITLE)}
          placeholder={t(ID_NUMBER_INPUT_PLACEHOLDER)}
          value={idNumber}
          onChange={(e) => onIdNumberChange(e.target.value)}
          error={t(idNumberError)}
          blocked={!isRepresentativeIdNumberEditable}
          dataTestId={TEST_IDS.representedEntityData.representativeIdNumberInput}
        />
        <Select
          title={t(REPRESENTATIVE_ROLE_TITLE)}
          placeholder={t(REPRESENTATIVE_ROLE_PLACEHOLDER)}
          value={representativeRelationType}
          options={representativeTypeOptions}
          setSelectedValue={onRepresentativeRelationTypeChange}
          disabled={!isRepresentativeRelationTypeEditable}
          dataTestId={TEST_IDS.representedEntityData.representativeRelationTypeSelect}
          color={representativeRelationType ? blackColor : colors.grey500}
        />
        {representativeRelationTypeError ? (
          <InlineWarning message={t(representativeRelationTypeError)} />
        ) : null}
        <RepresentativeInfoMessage />
      </Fields>
    </Section>
  );
};
